import { Container } from "@mui/material";
import ItemList from "../../components/ItemList";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";


const MachineBrand = () => {
  const fieldsConfig = [
    { key: "uuid", label: "Placeholder", type: "text", displayForm: false, displayList: false },
    { key: "brand", label: "Marca", type: "text", required: true, displayForm: true, displayList: true },];

  return (
    <Container maxWidth={false} disableGutters>
      <Box sx={{ display: "flex", justifyContent: "flex-start", marginBottom: "3%" }}>
        <Typography variant="h5" noWrap component="div"> 
          Marcas
        </Typography>
      </Box>
      <ItemList fields={fieldsConfig} tableName="machine_brands" hasCheckbox={true} objectName={"machine brand"} tabledescription={"Marcas de maquinas"}/>
    </Container>
  );
};

export default MachineBrand;
